import React, {Component} from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import {connect} from "react-redux";
import {registerField, change, getFormValues} from "redux-form";
import {withStyles} from "@material-ui/core/styles";
import Grid from "@material-ui/core/Grid";
import Slider from "@material-ui/lab/Slider";

import styles from "./age-slider.module.scss";

const materialStyles = {
  track: {
    height: `6px`,
    borderRadius: `3px`
  },
  trackBefore: {
    backgroundColor: `#b3de83`
  },
  thumb: {
    border: `2px solid #79a942`,
    height: `19px`,
    width: `19px`,
    borderRadius: `10px`,
    backgroundColor: `#fff`
  },
  trackAfter: {
    backgroundColor: `#79a942`,
    opacity: `1`
  }
};

class AgeSlider extends Component {
  static propTypes = {
    prop: PropTypes
  };
  componentDidMount() {
    this.props.registerField(`quiz`, `age`, `number`);
    this.props.change(`quiz`, `age`, 24);
  }
  handleChange = (_, value) => {
    this.props.change(`quiz`, `age`, value);
  };
  getAges(age) {
    if (age >= 10 && age <= 20) {
      return `${age} лет`;
    } else if (`${age}`.slice(-1) <= 4 && `${age}`.slice(-1) > 1) {
      return `${age} года`;
    } else if (`${age}`.slice(-1) === `1`) {
      return `${age} год`;
    } else {
      return `${age} лет`;
    }
  }
  render() {
    const {
      classes,
      values: {age}
    } = this.props;
    return (
      <Grid container>
        <Grid container className={styles.labelContainer}>
          <div className={classNames(styles.label, styles.startLabel)}>
            0 лет
          </div>
          <div style={{left: `${age}%`}} className={styles.label}>
            {this.getAges(age)}
          </div>
          <div className={classNames(styles.label, styles.endLabel)}>
            100 лет
          </div>
        </Grid>
        <Slider
          onChange={this.handleChange}
          step={1}
          min={0}
          max={100}
          value={age}
          classes={{
            track: classes.track,
            trackBefore: classes.trackBefore,
            trackAfter: classes.trackAfter,
            thumb: classes.thumb
          }}
        />
        <Grid container className={styles.marks}>
          {[0, 25, 50, 75, 100].map((mark) => (
            <span
              key={mark}
              className={classNames(styles.mark, styles[`mark${mark}`])}
            >
              {mark}
            </span>
          ))}
        </Grid>
      </Grid>
    );
  }
}
AgeSlider.propTypes = {
  classes: PropTypes.object,
  registerField: PropTypes.func,
  change: PropTypes.func,
  values: PropTypes.object
};

export default connect(
  (state) => ({
    values: getFormValues(`quiz`)(state)
  }),
  {change, registerField}
)(withStyles(materialStyles)(AgeSlider));
